import { useContext, useEffect, useState } from "react";
import { ModalContext } from "../providers/modal.provider";
import { InvoicesPayGeneral, InvoicesPayHeartlandDto } from "../services/invoice";
import { HeartlandIFrameComponent } from "../components/cpv-store/heartland-iframe";
import { count } from "../helpers/util.helper";
import IComponentState, { ComponentStateDto, ComponentStateLoadingDto, ComponentStateReadyDto } from "../interfaces/component-state.interface";

const useOrderSummaryHook = (orderData: any, ready?: boolean) => {
    const { setModalAttr, setModalActive, setModalBody } = useContext(ModalContext);
    const [ orderOpen, setOrderOpen ] = useState<boolean>(false);
    const [ order, setOrder ] = useState<any>(orderData || {});
    const [ onCancelEvent, setOnCancelEvent ] = useState<any>(() => {});
    const [ onSuccessEvent, setOnSuccessEvent ] = useState<any>(() => {});
    const [ paymentMethod, setPaymentMethod ] = useState<'cc' | 'crypto'>('cc');
    const [ orderState, setOrderState ] = useState<IComponentState>({...ComponentStateDto, ready: ready || false});
    const [ refreshOrder, setRefreshOrder ] = useState<boolean>(false);

    console.log(orderOpen);
    useEffect(() => {
      if(count(order) > 0 && refreshOrder) {
        if(!orderState.loading) {
            setOrderState(ComponentStateLoadingDto);
          setOrderOpen(true);
          InvoicesPayGeneral<InvoicesPayHeartlandDto>({...order, paymentMethod}).then(r => {
            setRefreshOrder(false);
              if(r.success) {
                  if(onSuccessEvent)
                      onSuccessEvent(r)
                  else {
                      setModalAttr({fullScreen: true})
                      setModalActive(true)
                      setModalBody(
                          <HeartlandIFrameComponent
                              cart={ {...r.data || {}, order_type: order.order_type || 'subscription', orderRequest: order } }
                              onCancelEvent={ onCancelEvent }
                          />
                      );
                  }
                  setOrderState(ComponentStateReadyDto);
              }
              else
                  throw new Error('An error occurred trying to create a payment.');
          }).finally(() => {
              setOrderState(ComponentStateReadyDto);
          });
        }
    }
    }, [paymentMethod]);
    return {
        setOrder,
        setOnCancelEvent,
        setOnSuccessEvent,
        setOrderOpen,
        setPaymentMethod,
        order,
        paymentMethod,
        orderState,
        setOrderState,
        refresh: () => setRefreshOrder(true),
    };
}

export default useOrderSummaryHook;